import CreateInvestmentOrWithdrawalPlan from './CreatePlanContainer';

export default CreateInvestmentOrWithdrawalPlan;